import { Controller } from "@hotwired/stimulus";

// Behavior for a single Toast::Component instance (server-rendered flash or a
// clone spawned by window.showToast in app/javascript/toast.js): auto-dismiss
// after data-toast-dismiss-after-value ms, and the dismiss button action.
// Connects to data-controller="toast".
export default class extends Controller {
  static values = {
    dismissAfter: Number,
  };

  connect() {
    if (this.dismissAfterValue) {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue);
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  dismiss() {
    const toast = this.element;
    toast.classList.remove("animate-slide-in-right");
    toast.classList.add("animate-slide-out-right");

    setTimeout(() => {
      toast.remove();

      // Remove the floating container once empty
      const container = document.getElementById("toast-container");
      if (container && container.children.length === 0) {
        container.remove();
      }
    }, 300);
  }
}
